import produce from 'immer';
import { ICounters } from '../api/models/counters/counters.types';
import { EFavoritesActionType, IFavoritesAction } from '../favorites/actions';
import { initialRootState } from '../initialRootState';
import { EVisitsActionType, IVisitsAction } from '../visits/actions';
import { ECountersActionType, ICountersAction } from './actions';

export type TCountersState = ICounters;

export const countersReducer = (
  currentState: TCountersState = initialRootState.counters,
  action: ICountersAction | IVisitsAction | IFavoritesAction
): TCountersState =>
  produce(currentState, draft => {
    switch (action.type) {
      case ECountersActionType.GET_SUCCESS: {
        const { message, visit, photoRequest, favorite } = action.payload;

        draft.favorite = favorite;
        draft.visit = visit;
        draft.message = message;
        draft.photoRequest = photoRequest;
        break;
      }
      case ECountersActionType.FAVORITE_COUNTER_UPDATE:
        draft.favorite = action.payload;
        break;
      case ECountersActionType.MESSAGE_COUNTER_UPDATE:
        draft.message = action.payload;
        break;
      case ECountersActionType.VISIT_COUNTER_UPDATE:
        draft.visit = action.payload;
        break;
      case ECountersActionType.PHOTO_REQUEST_COUNTER_UPDATE:
        draft.photoRequest = action.payload;
        break;
      case EVisitsActionType.GET_VISITS_SUCCESS:
        if (action.payload.isSub) {
          draft.visit = 0;
        }
        break;
      case EFavoritesActionType.GET_RECEIVED_FAVORITES_SUCCESS:
        if (action.payload.isSub) {
          draft.favorite = 0;
        }
        break;
    }
  });
